import { PopupSize } from '@/components/UI/Popup/Popup.types';

export const ACTIONS_HEIGHT = 50;

export const POPUP_SIZES: Record<PopupSize, string> = {
  medium: '305px',
  intermediate: '335px',
  large: '350px',
};
